export const TIDIO_STYLES = {
  DEFAULT: '#tidio { bottom: 0px !important; }',
  FIRST_VARIANT: '#tidio { bottom: 59px !important; }'
} as const
